module.exports = __webpack_public_path__ + "img/menu-icon-philosophy.6927a0fa.png";